import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2>This page unreachable, please try again....</h2>
        </div>
    );
};

export default NotFound;